import React from 'react';
import Home from "./Home";
import Connect from './Connect';
import Products from "./Products";
import Features from './Features';
import Trending from "./Trending";
import Connect2 from './Connect2';
import Connect3 from './Connect3';

const Salary = () => {





    return (
        <>
            <Home />
            <Connect />
            <Products />
            <Features />
            <Trending />
            <Connect2 />
            <Connect3 />

        </>
    );
};

export default Salary;